import axios from 'axios';
import store from "../store";

const PREFIJO = "/api/";

export default {
    lstLicitud() {
        return axios.all([
            this.tipoPersona(),
            this.generos(),
            this.paises(),
            this.tipoDocumento(),
            this.proviniasConChill(),
            this.estadosCiviles(),
            this.tipoDireccion(),
            this.relacionLaboral(),
            this.tipoActividadEconomica(),
            this.sectorLaboral(),
        ]);
    },
    lstSituacionFinanciera() {
        return axios.all([
            this.tipoActivo(),
            this.tipoPasivo(),
            this.tipoIngreso(),
            this.tipoGasto(),
            this.entidadesBancarias(),
            this.tipoInmuebles(),
            this.marcas(),
        ]);
    },

    generos() {
        return axios.post(`${PREFIJO}Gnr/VmSlGnr`);
    },
    entidadesBancarias() {
        return axios.post(`${PREFIJO}Bnc/VmSlBnc`);
    },
    tipoCuentaBancaria() {
        return axios.post(`${PREFIJO}TpCtBnc/VmSlTpB`);
    },
    paises() {
        return axios.post(`${PREFIJO}Ps/VmSlPs`);
    },
    proviniasConChill() {
        return axios.post(`${PREFIJO}Prv/VmSlPrvc`);
    },
    tipoDocumento() {
        return axios.post(`${PREFIJO}TpDcmt/VmTpDc`);
    },
    tipoDireccion() {
        return axios.post(`${PREFIJO}TpDrc/VmSlTpD`);
    },
    tipoParentesco() {
        const dto = {
            ndt1: 1
        };
        return axios.post(`${PREFIJO}TpPrnst/VmSlPrn`, dto);
    },
    relacionLaboral() {
        return axios.post(`${PREFIJO}RlcLbr/VmSlRlc`);
    },
    sectorLaboral() {
        return axios.post(`${PREFIJO}SctLbr/VmSlSct`);
    },
    tipoActividadEconomica() {
        return axios.post(`${PREFIJO}TpAcEc/VmSlAcC`);
    },
    tipoActivo() {
        return axios.post(`${PREFIJO}TAct/VmSlTAv`);
    },
    estadosCiviles() {
        return axios.post(`${PREFIJO}StdCvl/VmSlStC`);
    },
    tipoPasivo() {
        const dto = {
            id: store.getters.getCotizacion.id,
        };
        return axios.post(`${PREFIJO}TPsv/VmSlTPv`, dto);
    },
    tipoIngreso() {
        const dto = {
            id: store.getters.getCotizacion.id,
        };
        return axios.post(`${PREFIJO}TpIn/VmSlTIn`, dto);
    },
    tipoGasto() {
        const dto = {
            id: store.getters.getCotizacion.id,
        };
        return axios.post(`${PREFIJO}TpGt/VmSlTGt`, dto);
    },
    tipoPersona() {
        return axios.post(`${PREFIJO}TpPrs/VmSlTpPr`);
    },
    listaPlazos(financiera) {
        const dto = {
            dt1: "CREDITO",
            dt2: financiera.producto,
            ndt2: financiera.id,
            ndt3: financiera.plan,
            dt3: 'ACTIVO',
        };
        return axios.post(`${PREFIJO}FnPl/VmSlFnP`, dto);
    },
    tipoInmuebles() {
        return axios.post(`${PREFIJO}TpMbl/VmSlTMb`);
    },
    marcas() {
        return axios.post(`${PREFIJO}Mrc/VmSlMrc`);
    },
    modelos(id){
        const dto = {
            id: id
        };
        return axios.post(`${PREFIJO}MdlGrd/VmSlMdG`,dto)
    },
    tipoDocumentoPersona(){
        const dto={
            //bdt1:
        };
        return axios.post(`${PREFIJO}TpDcmP/VmTpDc`,dto)
    },
    listaCuentasAgencia(){
        const dto={
            ndt1:store.getters.getCotizacion.ndt6
        };
        return axios.post(`${PREFIJO}GncBncCn/VmSlGnCn`,dto)
    },
    tipoEmail(){
        return axios.post(`${PREFIJO}Aplc/VmTpMls`);
    },
    tipoTelefono(){
        return axios.post(`${PREFIJO}Aplc/VmTpTls`);
    },
};
